import { render, staticRenderFns } from "./Maintenance.vue?vue&type=template&id=6023f53f&scoped=true&"
import script from "./Maintenance.vue?vue&type=script&lang=ts&"
export * from "./Maintenance.vue?vue&type=script&lang=ts&"
import style0 from "./Maintenance.vue?vue&type=style&index=0&id=6023f53f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6023f53f",
  null
  
)

export default component.exports